<!--
 * @Author: your name
 * @Date: 2020-10-27 09:37:56
 * @LastEditTime: 2020-11-18 17:00:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \cs_pc\src\components\Footer.vue
-->
<template>
  <div class="mall-head">
    <div class="head-info">
      <div class="mall-head-wrap max-width">
        <div class="head-l">服务热线：{{ $store.state.websiteTel }}</div>
        <div class="head-r">
          <span>您好，请登录</span>
          <span
            v-for="(item, index) in navList"
            :key="index"
            @click.stop="changeUrl(item)"
            >{{ item.title }}</span
          >
        </div>
      </div>
    </div>
    <div class="search-info">
      <div class="mall-head-search max-width">
        <div class="search-l" @click.stop="$router.push('/')">
          <img src="@/assets/images/logo.png" /><span>齐心福利</span>
        </div>
        <div class="search-r">
          <div class="select">
            深圳<img src="@/assets/images/arrow_down.png" />
          </div>
          <div class="search-text">
            <span>电影票、话剧票、健身...</span>
            <img src="@/assets/images/search_icon.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      navList: [
        {
          title: "商城首页",
          kind: 1,
          path: "",
        },
        {
          title: "我的账号",
          path: "",
        },
        {
          title: "购物车",
          path: "",
        },
        {
          title: "绑卡流程",
          path: "",
        },
      ],
    };
  },
  methods: {
    changeUrl(item) {
      if (item.kind) {
        window.open(this.$pathUrls.shop_pc);
      } else if (item.path) {
        this.$store.dispatch("changeRouter", { path: item.path, query: {} });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.mall-head {
  .mall-head-wrap {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    .head-l {
    }
    .head-r {
      span {
        padding: 0 20px;
        border-left: 1px solid #ccc;
        cursor: pointer;
        &:first-child {
          border: none;
        }
      }
    }
  }
  .search-info {
    background: #fff;
    padding: 45px 0;
    .mall-head-search {
      display: flex;
      align-items: center;
      font-size: 16px;
      .search-l {
        display: flex;
        align-items: center;
        cursor: pointer;
        min-width: 300px;
        span {
          font-size: 30px;
          font-weight: bold;
          padding-left: 20px;
        }
      }
      .search-r {
        margin-left: 110px;
        display: flex;
        align-items: center;
        border-radius: 10px;
        border: solid 1px #eeeeee;
        width: 600px;
        height: 40px;
        padding: 0 20px;
        .select {
          padding-right: 20px;
          margin-right: 20px;
          border-right: 1px solid #eee;
          color: #ff2f2f;
          display: flex;
          align-items: center;
          img {
            margin-left: 5px;
            height: 6px;
          }
        }
        .search-text {
          width: calc(~"100% - 90px");
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #666666;
          img {
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MallHead.vue